<template>
  <div>
    <b-list-group class="mb-1">
      <b-list-group-item>
        <div>
          <div class="text-primary font-weight-bold">
            Tarih
          </div>
          <div>{{ moment(dataItem.wdate).format('DD.MM.YYYY') }}</div>
        </div>
      </b-list-group-item>
      <b-list-group-item>
        <div>
          <div class="text-primary font-weight-bold">
            Çalışma Saatleri
          </div>
          <div>{{ moment(dataItem.wdate + ' ' + dataItem.stime).format('HH:ss') }} - {{ moment(dataItem.wdate + ' ' + dataItem.etime).format('HH:ss') }}</div>
        </div>
      </b-list-group-item>
      <b-list-group-item>
        <div>
          <div class="text-primary font-weight-bold">
            Çalışma Personeller
          </div>
          <div v-if="dataItem.workers.length">
            <b-badge
              v-for="worker in dataItem.workers"
              :key="worker.id"
              class="mr-1 mt-1"
              variant="light-primary"
            >
              {{ worker.name }}
            </b-badge>
          </div>
          <div
            v-else
            class="text-danger"
          >
            Tanımsız
          </div>
        </div>
      </b-list-group-item>
      <b-list-group-item>
        <div>
          <div class="text-primary font-weight-bold">
            Açıklama
          </div>
          <div>
            <div v-html="dataItem.content" />
          </div>
        </div>
      </b-list-group-item>
      <b-list-group-item>
        <b-button
          v-if="dataItem.images.length > 0"
          variant="danger"
          @click="setModal(dataItem.images)"
        >
          <FeatherIcon icon="PaperclipIcon" />
          Fotoğraf Ekleri ({{ dataItem.images.length }})
        </b-button>
        <b-alert
          v-else
          show
          variant="danger"
          class="mt-1"
        >
          <div class="alert-body text-center">
            Çalışma notu için hiç fotoğraf yüklenmemiş.
          </div>
        </b-alert>
      </b-list-group-item>
      <b-list-group-item>
        <div class="text-muted text-italic">
          {{ moment(dataItem.created).format('llll') }} tarihinde {{ dataItem.username }} tarafından oluşturuldu.
        </div>
      </b-list-group-item>
    </b-list-group>
    <b-modal
      v-model="photosModal.status"
      hide-footer
      title="Fotoğraflar"
      size="lg"
      centered
    >
      <b-row no-gutters>
        <b-col
          v-for="item in photosModal.dataList"
          :key="item.id"
          cols="12"
        >
          <div class="mb-2">
            <b-img
              :src="item.photo"
              fluid
            />
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import {
  BBadge, BCol, BImg, BRow, BListGroup, BListGroupItem, BButton, BModal, BAlert,
} from 'bootstrap-vue'

export default {
  name: 'WorkItem',
  components: {
    BBadge,
    BImg,
    BRow,
    BCol,
    BListGroup,
    BListGroupItem,
    BButton,
    BModal,
    BAlert,
  },
  props: {
    dataItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      photosModal: {
        status: false,
        dataList: [],
      },
    }
  },
  methods: {
    setModal(dataList) {
      this.photosModal.status = true
      this.photosModal.dataList = dataList
    },
  },
}
</script>

<style scoped>
.image-container{
  aspect-ratio: 4/3;
  overflow: hidden;
  display: flex;
  align-items: center;
  border: 1px solid #f1f1f1;
  margin: 5px;
}
</style>
